import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import statusActions from './status-actions'

/*

Responsible for loading indicator and modal messages.

*/

function mapStateToProps(state, intialProps){
    return {
        ...intialProps,
        status: state.status
    }
}


function mapDispatchToProps(dispatch, props){
    return {
        actions:{
            ...props.actions,
            status: bindActionCreators(statusActions, dispatch)
        }
    }
}


export const withStatus = (Wrapped:React.ComponentClass) => {

    return connect(mapStateToProps, mapDispatchToProps)(class extends React.Component<any, any>{

        render(){
            return <Wrapped { ...this.props } />
        }

    })

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/status/index.tsx